module.exports = __webpack_public_path__ + "img/gb96-85-10.prt.cfc6b358.jpg";